import { Controller, useFormContext } from 'react-hook-form';

import useTranslation from '@/utils/hooks/translation/useTranslation';

//type
import type { PlatformFormType } from '@/components/pages/settings/platform/types';

//libs
import { languages_available } from '@/lib/settings/optionsConfiguration/platformSettings/languagesAvailable';

//components
import { SelectComponent } from '@/components/base/Select/SelectComponent/SelectComponent';

export function PlatformAutoTranslate() {
    const { t } = useTranslation('settings');

    const options = languages_available(t);

    const {
        control,
        formState: { errors }
    } = useFormContext<PlatformFormType>();

    return (
        <Controller
            key={'posts_auto_translate'}
            control={control}
            name={'posts_auto_translate'}
            render={({ field: { onChange, value } }) => {
                return (
                    <SelectComponent
                        selected={options?.find((item) => value['value'] === item.value)}
                        setSelected={onChange}
                        label={t('platform_page.posts_auto_translate')}
                        error={errors.posts_auto_translate?.message}
                        options={options}
                    />
                );
            }}
        />
    );
}
